module.exports = __webpack_public_path__ + "static/media/circle.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Tekentool/assets/alternate/circle.svg
// module id = 60
// module chunks = 0